<template>
<div class="chapter">
<div class="inner_page">
<h2 class="title1"><em>Martine Bailey</em></h2>
<h1 class="title">A Taste for Nightshade</h1>
<div class="space">
<p class="center">Thomas Dunne Books <br/>St. Martin’s Press <br/>New York</p>
<p class="img1"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?c6cb6cb8